import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleMoveListElement(
  milestone: Identifiable<Milestone>,
): Identifiable<Milestone> {
  return milestone;
}

export { handleMoveListElement };
